import { useState } from "react";
import api from "../lib/api";
import { X, Bell } from "@phosphor-icons/react";

export default function WaitlistModal({ instance, tour, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", party_size: 2 });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name || !form.email) { setError("Name and email are required."); return; }
    setSubmitting(true);
    try {
      const r = await api.post("/waitlist/join", {
        instance_id: instance.id,
        name: form.name,
        email: form.email,
        phone: form.phone,
        party_size: Number(form.party_size) || 2,
      });
      setResult(r.data);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not join the waitlist.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="waitlist-modal">
      <div className="bg-ms-ivory border border-ms-edge rounded-md max-w-lg w-full p-7" onClick={e => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <p className="label-eyebrow text-ms-brass flex items-center gap-1.5"><Bell size={14} weight="duotone" /> Waitlist</p>
            <h2 className="serif text-2xl text-ms-ink mt-2">{tour.title}</h2>
            <p className="text-ms-stone text-sm mt-1">{new Date(instance.starts_at).toLocaleString(undefined, {weekday:'long', month:'long', day:'numeric', hour:'numeric', minute:'2-digit'})}</p>
          </div>
          <button onClick={onClose} className="text-ms-stone hover:text-ms-ink" data-testid="waitlist-close"><X size={20} /></button>
        </div>

        {result ? (
          <div className="mt-6" data-testid="waitlist-success">
            <p className="text-ms-success text-sm leading-relaxed">
              {result.already_joined ? "You're already on the list — " : "You're on the list! "}
              You're <b>#{result.position}</b> in line. If a seat opens, we'll email you with a 30-minute head start to claim it before it goes back on sale.
            </p>
            <button onClick={onClose} className="mt-6 btn-primary w-full">Close</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" required className="w-full border border-ms-edge rounded-md px-3 py-2.5 text-sm" data-testid="waitlist-name" />
            <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email" required className="w-full border border-ms-edge rounded-md px-3 py-2.5 text-sm" data-testid="waitlist-email" />
            <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Phone (optional)" className="w-full border border-ms-edge rounded-md px-3 py-2.5 text-sm" data-testid="waitlist-phone" />
            <label className="block">
              <span className="text-xs text-ms-stone">Party size</span>
              <input
                type="number" min="1" max="20"
                value={form.party_size}
                onChange={e => setForm({ ...form, party_size: e.target.value })}
                className="mt-1 w-full border border-ms-edge rounded-md px-3 py-2.5 text-sm"
                data-testid="waitlist-party-size"
              />
            </label>
            {error && <p className="text-ms-danger text-sm" data-testid="waitlist-error">{error}</p>}
            <button type="submit" disabled={submitting} className="btn-primary w-full disabled:opacity-40" data-testid="waitlist-submit">
              {submitting ? "Adding you…" : "Join waitlist"}
            </button>
            <p className="text-xs text-ms-stone text-center mt-3">No charge to join. We only email if a spot opens.</p>
          </form>
        )}
      </div>
    </div>
  );
}
